import { httpClient } from '../core/http';
import { AppApiKeyScope, AppApiScopeUpdateRequest } from '../types';

type ApiKeyScopeListResponse = {
  items: AppApiKeyScope[];
  count: number;
};

export type ApiKeyScopeForTool = {
  api_key_id: number;
  tool_id: string;
  tool_name: string;
  can_read: boolean;
  can_write: boolean;
  created_at?: string | null;
};

export type ApiKeyScopesByKeyResponse = {
  api_key_id: number;
  items: ApiKeyScopeForTool[];
  count: number;
};

export class ApiKeyScopeService {
  private readonly basePath = '/v1/tools';
  private readonly orgBasePath = '/v1/organizations';

  async listScopes(toolId: string): Promise<ApiKeyScopeListResponse> {
    const response = await httpClient.get<ApiKeyScopeListResponse>(
      `${this.basePath}/${toolId}/api-key-scopes`
    );
    return response.data;
  }

  async upsertScope(
    toolId: string,
    payload: AppApiScopeUpdateRequest
  ): Promise<AppApiKeyScope> {
    const response = await httpClient.put<AppApiKeyScope>(
      `${this.basePath}/${toolId}/api-key-scopes`,
      payload
    );
    return response.data;
  }

  /**
   * Visao "por chave" — lista todas as tools que esta API key acessa.
   * Usada na tela /profile para o owner ver tudo num lugar so.
   */
  async listScopesByApiKey(
    organizationId: number,
    apiKeyId: number
  ): Promise<ApiKeyScopesByKeyResponse> {
    const response = await httpClient.get<ApiKeyScopesByKeyResponse>(
      `${this.orgBasePath}/${organizationId}/api-keys/${apiKeyId}/scopes`
    );
    return response.data;
  }

  async upsertScopeForTool(
    organizationId: number,
    apiKeyId: number,
    toolId: string,
    payload: { can_read: boolean; can_write: boolean }
  ): Promise<ApiKeyScopeForTool> {
    const response = await httpClient.put<ApiKeyScopeForTool>(
      `${this.orgBasePath}/${organizationId}/api-keys/${apiKeyId}/scopes/${toolId}`,
      payload
    );
    return response.data;
  }

  async deleteScopeForTool(
    organizationId: number,
    apiKeyId: number,
    toolId: string
  ): Promise<void> {
    await httpClient.delete(
      `${this.orgBasePath}/${organizationId}/api-keys/${apiKeyId}/scopes/${toolId}`
    );
  }
}

export const apiKeyScopeService = new ApiKeyScopeService();
